


































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class FilterShadow2 extends Vue {
}
